module.exports = __webpack_public_path__ + "img/logo.6130dd2e.png";